import type {
  IMessageDetails,
  IMessageDetailsInternalEvent,
  MessageDetails,
  MessageDetailsWithOnlySubjectUri,
} from '~/features-shared/timeline/interfaces/timeline'

/** Is provided message details is a MessageDetailsWithOnlySubjectUri. */
export function isMessageDetailsWithOnlySubjectUri(
  messageDetails: MessageDetails,
): messageDetails is MessageDetailsWithOnlySubjectUri {
  return typeof (messageDetails as MessageDetailsWithOnlySubjectUri).subject_uri === 'string'
}

/** Is provided message details is a IMessageDetailsInternalEvent. */
export function isMessageDetailsInternalEvent(
  messageDetails: MessageDetails,
): messageDetails is IMessageDetailsInternalEvent {
  return typeof (messageDetails as IMessageDetailsInternalEvent).model_uri === 'string'
}

/** Is provided message details is a IMessageDetails. */
export function isMessageDetails(
  messageDetails: MessageDetails,
): messageDetails is IMessageDetails {
  return typeof (messageDetails as IMessageDetails).content === 'string'
}
